export default "__VITE_ASSET__D1L9rWrp__"